import React from "react";
const SvgLoginSaveFavourites = props => (
  <svg fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="#39434E"
      fillRule="evenodd"
      d="M19.67 5.885c0-1.106.97-1.885 2-1.885h2.328C25.03 4 26 4.779 26 5.885v6.365a.75.75 0 01-1.5 0V5.885c0-.143-.157-.385-.502-.385h-2.327c-.345 0-.501.242-.501.385v2.62a.75.75 0 01-1.5 0v-2.62z"
      clipRule="evenodd"
    />
    <path
      fill="#39434E"
      fillRule="evenodd"
      d="M14.704 6.955l-10.48 8.563a.75.75 0 11-.949-1.161L13.757 5.79a3.575 3.575 0 014.486 0l.001.001 10.48 8.565a.75.75 0 11-.949 1.161L17.296 6.955a2.077 2.077 0 00-2.592 0z"
      clipRule="evenodd"
    />
    <path
      fill="#39434E"
      fillRule="evenodd"
      d="M5.75 12.696a.75.75 0 01.75.75v12.201c0 1.027.826 1.849 1.806 1.849h6.018a.75.75 0 010 1.5H8.306C6.474 28.996 5 27.479 5 25.647V13.446a.75.75 0 01.75-.75z"
      clipRule="evenodd"
    />
    <path
      fill="#E4002B"
      fillRule="evenodd"
      d="M13 20.512c0-2.343 1.795-4.912 4.545-4.912a4.09 4.09 0 012.955 1.22 4.09 4.09 0 012.955-1.22c2.75 0 4.545 2.57 4.545 4.912 0 1.207-.474 2.341-1.16 3.35-.685 1.01-1.595 1.913-2.498 2.666a21.529 21.529 0 01-2.502 1.783 17.89 17.89 0 01-.847.488 6.991 6.991 0 01-.341.17.7.7 0 01-.074.024c-.008.002-.039.01-.078.01s-.07-.008-.078-.01a.424.424 0 01-.074-.025 6.991 6.991 0 01-.34-.17 15.696 15.696 0 01-.848-.487 21.529 21.529 0 01-2.502-1.783c-.903-.753-1.813-1.655-2.499-2.665-.686-1.01-1.159-2.144-1.159-3.35z"
      clipRule="evenodd"
    />
    <path
      fill="#F095A6"
      fillRule="evenodd"
      d="M24.63 17.413a.5.5 0 01.707-.033l.022.02a4.593 4.593 0 011.423 4.234.5.5 0 01-.983-.183 3.593 3.593 0 00-1.113-3.311l-.023-.02a.5.5 0 01-.033-.707z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgLoginSaveFavourites;
